const saturday = [
  {
    time: "9:00 am",
    activity: "Check-In Opens and Visiting",
    location: "Living Room"
  },
  {
    time: "9:30 am",
    activity: "Family Photos and Memorabilia Sharing (continuing throughout the day)",
    location: "Living Room"
  },
  {
    time: "10:00 am",
    activity: "Making Tie-Dye Shirts",
    location: "Gym"
  },
  {
    time: "10:30 am",
    activity: "Kid's Games and Activities",
    location: "Outdoors/Gym"
  },
  {
    time: "10:30 am",
    activity: "Time for Visiting",
    location: "Living Room"
  },
  {
    time: "10:30 am",
    activity: "Turn in Cookie Contest Entries",
    location: "Living Room"
  },
  {
    time: "11:00 am",
    activity: "FAMILY PICTURES",
    location: "Living Room"
  },
  {
    time: "12 Noon",
    activity: "Lunch Buffet – Deli Sandwich Bar provided plus Potluck Sides, Salads, and Desserts",
    location: "Gym"
  },
  {
    time: "1:30 pm",
    activity: "Talent Show",
    location: "Living Room"
  },
  {
    time: "2:30 pm",
    activity: "Cookie Contest Judging",
    location: "Gym"
  },
  {
    time: "2:30 pm",
    activity: "Kid's Games",
    location: "Outdoors/Gym"
  },
  {
    time: "3:30 pm",
    activity: "Announce Cookie Contest Winners",
    location: "Living Room"
  },
  {
    time: "4:00 pm",
    activity: "Auction Begins - Silent Auction Closes",
    location: "Living Room"
  },
  {
    time: "5:30 pm",
    activity: "Supper – Catered Dinner (with Contest Cookies for dessert!)",
    location: "Gym"
  },
  {
    time: "6:00 pm",
    activity: "Family Meeting",
    location: "Living Room"
  },
  {
    time: "7:00 pm",
    activity: "Cleanup following meeting",
    location: "Gym/Living Room"
  },
];

const sunday = [
  {
    time: "9:00 am",
    activity: "London Meeting Room Opens",
    location: "Hampton Inn"
  },
  {
    time: "10:30 am",
    activity: "Sunday Message and Music",
    location: "London Meeting Room"
  },
  {
    time: "After the message and music",
    activity: "Bring your own 'Picnic' Lunch and Visiting",
    location: "London Meeting Room"
  },
];

export { saturday, sunday }
